export default phoneNumber => phoneNumber.trim().replace(/[^\d]/g, "").length === 10;
